<template>
  <card :title="$t('pages.profile.sections.account.title')">
    <div class="flex flex-col gap-y-5 items-start">
      <div class="grid gap-5 grid-cols-2 grid-rows-2 flex-1">
        <TextInput
          name="lastLogin"
          :model-value="lastLogin"
          :label="$t('user.lastLogin')"
          disabled
        />
        <TextInput
          type="text"
          name="userRole"
          :model-value="rolesDisplay"
          :label="$t('user.userRole')"
          disabled
        />
        <TextInput
          type="text"
          name="accountStatus"
          :model-value="user.active"
          :label="$t('user.accountStatus')"
          disabled
        />
      </div>
    </div>
  </card>
</template>

<script lang="ts" setup>
import Card from "@components/utils/Card.vue";
import TextInput from "@components/utils/inputs/Input.vue";
import { syncRef } from "@/hooks/state";
import { useStore } from "@/store";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { format } from "date-fns";

const store = useStore();
const user = syncRef(
  computed(() => store.state.auth.user),
  (u) => ({ ...u })
);
const { t } = useI18n();
const rolesDisplay = computed(() =>
  user.value.roles?.map((role) => t(`user.roles.${role}`)).join(", ")
);
const lastLogin = computed(() =>
  user.value?.lastLogin ? format(new Date(user.value?.lastLogin), "dd.MM.yyyy HH:mm:ss") : t("never")
);
</script>

<style lang="scss" scoped></style>
